<template>
  <StepLayout pageId="page-4-1" title="Deposit Payment">
    <div class="deposit-payment-wrap">
      
      <div class="price-display">
        &pound;<span id="total">{{ (50.0 * currentSize).toFixed(2) }}</span>
      </div>

      <div class="payment-method-section">
        <div class="section-title">Payment Method</div>
        
        <div class="payment-list">
          <div 
            class="payment-item" 
            :class="{ active: deposite === 'Card' }"
            @click="depositeTabs('Card')"
          >
            <div class="item-left">
              <img src="/static/images/card_icon.svg" class="method-icon" />
              <span class="method-name">Credit/Debit Card</span>
            </div>
            <div class="item-right">
              <a-radio :checked="deposite === 'Card'" class="custom-radio"></a-radio>
            </div>
          </div>
        </div>
      </div>

      <div id="emptyCol" v-show="deposite === 'Poynt' || deposite === 'Paymentsense'">
        <h6>Oh-uh, you dont seem to have <span>{{ deposite }}</span> activated.</h6>
        <p>Please contact support to enable <span>{{ deposite }}</span>.</p>
      </div>

      <div class="deposit-tip">
        <img src="/static/images/bulb_icon.svg" class="tip-icon" />
        <p class="tip-text">
          This small deposit ensures your table is reserved and ready when you arrive. It's fully refundable.
        </p>
      </div>
    </div>

    <!-- Hidden form inputs for compatibility with old jQuery interactions -->
    <form id="depositCreateForm" style="display: none;">
      <input type="hidden" name="user_id" value="" />
      <input type="hidden" name="reserve_id" value="" />
      <input type="hidden" name="money" id="money" value="" />
      <input type="hidden" name="payment" id="payment" value="" />
    </form>

  </StepLayout>
</template>

<script>
import StepLayout from "./StepLayout.vue";

export default {
  name: "ReservationStep5",
  components: {
    StepLayout
  },
  mounted() {
    // Ensure 'Card' is selected by default
    if (this.deposite !== 'Card') {
      this.$emit("depositeTabs", "Card");
    }
  },
  props: {
    infoForm: Object,
    depositeArr: Array,
    deposite: String,
    currentSize: [String, Number]
  },
  methods: {
    depositeTabs(item) { 
      this.$emit("depositeTabs", item); 
    },
    next() { 
      if (this.deposite === 'Poynt' || this.deposite === 'Paymentsense' || !this.deposite) {
        return;
      }
      this.$emit("next"); 
    }
  }
};
</script>

<style lang="scss" scoped>
.deposit-payment-wrap {
  text-align: left;
  
  .price-display {
    font-size: 36px;
    font-weight: 700;
    color: #202020;
    text-align: center;
    margin: 30px 0 45px;
  }

  .payment-method-section {
    margin-bottom: 20px;

    .section-title {
      font-size: 16px;
      font-weight: 500;
      color: #202020;
      margin-bottom: 15px;
    }

    .payment-list {
      display: flex;
      flex-direction: column;

      .payment-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 0;
        cursor: pointer;
        /* Optional separator line, commented out by default to match clean layout */
        /* border-bottom: 1px solid #f6f6f6; */

        &:last-child {
          border-bottom: none;
        }

        .item-left {
          display: flex;
          align-items: center;
          gap: 12px;

          .method-icon {
            width: 24px;
            height: 20px;
            object-fit: contain;
          }

          .method-name {
            font-size: 16px;
            color: #202020;
            font-weight: 500;
          }
        }

        .item-right {
          display: flex;
          align-items: center;

          /* Make the radio feel like a display element and let div catch click */
          .custom-radio {
            pointer-events: none;
          }
          ::v-deep .ant-radio-inner {
            width: 20px;
            height: 20px;
            border-color: #d9d9d9;
          }
          ::v-deep .ant-radio-checked .ant-radio-inner {
            border-color: var(--brandColor);
          }
          ::v-deep .ant-radio-checked .ant-radio-inner::after {
            background-color: var(--brandColor);
            width: 10px;
            height: 10px;
            top: 4px;
            left: 4px;
          }
        }
      }
    }
  }

  #emptyCol {
    text-align: center;
    padding: 20px 0;
    h6 {
      font-size: 14px;
      color: #333;
      margin: 10px 0;
      span {
        font-weight: bold;
      }
    }
    p {
      font-size: 12px;
      color: #666;
    }
  }

  .deposit-tip {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 40px;

    .tip-icon {
      width: 16px;
      height: 16px;
      margin-top: 2px;
      flex-shrink: 0;
    }

    .tip-text {
      font-size: 13px;
      color: #7B7D7F;
      line-height: 1.5;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReservationStep5.vue